// latestScanTimeReducer.js
import { SET_LATEST_SCAN_TIME, SET_LATEST_K8S_SCAN_TIME } from '@root/constants/actionTypes';

const initialState = {
  latest_scan: null,
  latest_scan_id: null,
  latest_k8s_scan: null,
};

const latestScanTimeReducer = (state = initialState, action) => {
  if (action.type === SET_LATEST_SCAN_TIME) {
    return {
      ...state,
      latest_scan: action.payload.last_updated,
      latest_scan_id: action.payload.scan_id,
    };
  } else if (action.type === SET_LATEST_K8S_SCAN_TIME) {
    return {
      ...state,
      latest_k8s_scan: action.payload.last_update,
    };
  }

  return state;
};

export default latestScanTimeReducer;
